import dayjs from '../utils/dayjs';

export const TimeHelper = {
  methods: {
    changeDataEventTimezone(data) {
      const STATUS_TOUR_WAITING_END = 4;
      const STATUS_TOUR_ENDED = 2;
      if (data.content && data.content.length > 0) {
        data.content.forEach((value, index) => {
          if (value.schedule === '0000-00-00 00:00:00') {
            return;
          }
          if (value.ec_datetime === '') {
            return;
          }
          const tournamentStatus = value.status;
          const startTour = dayjs.tz(value.schedule, 'America/Los_Angeles');
          const endTourCheck = value.end_time;
          let endTour = dayjs.tz(value.end_time, 'America/Los_Angeles');
          if (value.is_bracket && (tournamentStatus === STATUS_TOUR_WAITING_END || tournamentStatus === STATUS_TOUR_ENDED)) {
            endTour = dayjs.tz(value.updated_at, value.local_timezone);
          }
          if (!endTourCheck) {
            value.ec_datetime = startTour.local().format('MMMM Do YYYY hh:mma').toLocaleString();
            return;
          }
          if (endTourCheck === '0000-00-00 00:00:00') {
            endTour = dayjs.tz(value.schedule, 'America/Los_Angeles').add(8, 'hours');
          }
          const dateStartReturn = startTour.local().format('MMMM Do YYYY').toLocaleString();
          const timeStartReturn = startTour.local().format('hh:mma').toLocaleString();
          const timeEndReturn = endTour.local().format('hh:mma').toLocaleString();
          value.ec_date = dateStartReturn;
          value.ec_time = timeStartReturn + ' - ' + timeEndReturn + ' UTC' + this.getTimeZone();
          const dateStart = startTour.local().format('D').toLocaleString();
          const dateEnd = endTour.local().format('D').toLocaleString();
          const monthStart = startTour.local().format('M').toLocaleString();
          const monthEnd = endTour.local().format('M').toLocaleString();
          if (monthStart !== monthEnd) {
            value.ec_datetime = startTour.local().format('MMMM Do YYYY hh:mma').toLocaleString() + ' - ' + endTour.local().format('MMMM Do hh:mma').toLocaleString();
          } else if (dateStart === dateEnd) {
            value.ec_datetime = startTour.local().format('MMMM Do YYYY hh:mma').toLocaleString() + ' - ' + endTour.local().format('hh:mma').toLocaleString();
          } else {
            value.ec_datetime = startTour.local().format('MMMM Do YYYY hh:mma').toLocaleString() + ' - ' + endTour.local().format('Do hh:mma').toLocaleString();
          }
        });
      }
      return data;
    },

    getTimeZone() {
      const offset = new Date().getTimezoneOffset(), o = Math.abs(offset);
      return (offset < 0 ? '+' : '-') + ('00' + Math.floor(o / 60)).slice(-2) + ('00' + (o % 60)).slice(-2);
    },

    formatDate(input, token) {
      return dayjs(input).format(token);
    },

    /**
     * Converts user input date string to ISO format
     *
     * - new Date("12/17/2020") = "2020-12-17T08:00:00.000Z" (correct)
     * - new Date("2020-12-17") = "2020-12-17T00:00:00.000Z" (need conversion)
     */
    convertDateStringToISO(dateString) {
      const regexForMmDdYyyy = /^\d{2}\/\d{2}\/\d{4}$/; // MM/DD/YYYY
      const regexForYyyyMmDd = /^\d{4}-\d{2}-\d{2}$/; // YYYY-MM-DD
      const timezoneOffsetInMS = (new Date().getTimezoneOffset()) * 60 * 1000;
      let dateObject;

      if (regexForMmDdYyyy.test(dateString)) {
        dateObject = new Date(dateString);
      }
      if (regexForYyyyMmDd.test(dateString)) {
        dateObject = new Date(new Date(dateString).valueOf() + timezoneOffsetInMS);
      }

      if (!isNaN(dateObject.valueOf())) {
        return dateObject.toISOString();
      } else {
        return null;
      }
    },

    /**
     * Get datetime object of the closest hour from now
     */
    getClosestHour() {
      const interval = 60 * 60 * 1000; // 60 minutes in milliseconds
      return new Date(Math.ceil(new Date().getTime() / interval) * interval);
    },

    /**
     * Get timezone offset in seconds
     */
    getTimeZoneOffsetSeconds() {
      // negative to those regions west to UTC
      return (new Date().getTimezoneOffset()) * 60 * (-1);
    },

    /**
     * Determine if user is in DST period or not
     * @returns "1" for isInDST, "0" for not in DST
     */
    isInDST() {
      var temp = new Date();
      var jan = (new Date(temp.getFullYear(), 0, 1)).getTimezoneOffset();
      var jun = (new Date(temp.getFullYear(), 6, 1)).getTimezoneOffset();
      var today = temp.getTimezoneOffset();
      var isInDST = '0';
      if (today < Math.max(jan, jun)) {
        isInDST = '1';
      }
      return isInDST;
    },

    /**
     * Get timezone offset in seconds, wrapped under "timeZoneOffsetSeconds" key
     */
    getTimeZoneOffsetSecondsPayload() {
      return {
        timeZoneOffsetSeconds: TimeHelper.methods.getTimeZoneOffsetSeconds(),
        isDst: TimeHelper.methods.isInDST(),
      };
    },
  },
};
